module.exports = __webpack_public_path__ + "img/74.c4277b20.webp";